import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import { SelectionProvider } from "./context/SelectionContext";
import { ThemeProvider } from "./context/ThemeContext";
import { TabletModeProvider } from "./context/TabletModeContext";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboardNew from "./pages/admin/AdminDashboardNew";
import IntelligenceDashboard from "./pages/admin/IntelligenceDashboard";
import ReviewSettingsPage from "./pages/admin/ReviewSettingsPage";
import ProfitDashboard from "./components/Admin/ProfitDashboard";
import KitchenPanel from "./components/Admin/KitchenPanel";
import BarPanel from "./components/Admin/BarPanel";
import TableMenuWrapper from "./components/TableMenuWrapper";
import GuidedFlow from "./components/GuidedFlow";
import TimeClockPage from "./pages/TimeClockPage";
import LoveAndThanksWater from "./pages/landing/LoveAndThanksWater";
import QRExperience from "./pages/landing/QRExperience";
import B2BLanding from "./pages/B2BLanding";
import SystemPanel from "./pages/SystemPanel";
import PublicTicket from "./pages/PublicTicket";
import KioskMode from "./components/KioskMode";
import { Toaster } from "./components/ui/sonner";
import { initAnalytics } from "./lib/analytics";

// Protected route wrapper for admin
const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  useEffect(() => {
    initAnalytics();
    // Detect iframe → hide duplicate "Made with Emergent" badge
    if (window.self !== window.top) {
      document.body.classList.add('in-iframe');
    }
  }, []);

  return (
  <ThemeProvider>
    <LanguageProvider>
      <SelectionProvider>
        <TabletModeProvider>
        <div className="App">
          <Toaster position="top-center" richColors />
          <BrowserRouter>
            <KioskMode />
            <Routes>
              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route 
                path="/admin/*" 
                element={
                  <ProtectedAdminRoute>
                    <AdminDashboardNew />
                  </ProtectedAdminRoute>
                } 
              />
              
              {/* Guided Flow - DEV MODE (not linked from main menu) */}
              <Route path="/mesa/:tableNumber/guiado" element={<GuidedFlow />} />
              <Route path="/menu/guiado" element={<GuidedFlow />} />
              
              {/* Table QR route - THE MAIN CUSTOMER EXPERIENCE */}
              <Route path="/mesa/:tableNumber/*" element={<TableMenuWrapper />} />
              {/* Generic single-use session (no table linked) */}
              <Route path="/menu/*" element={<TableMenuWrapper />} />
              <Route path="/menu" element={<TableMenuWrapper />} />
              
              {/* Time Clock / Fichaje route - Direct access for employees */}
              <Route path="/fichar" element={<TimeClockPage />} />
              
              {/* Landing Page - Love & Thanks Water Presentation */}
              <Route path="/landing" element={<LoveAndThanksWater />} />
              <Route path="/love-thanks-water" element={<LoveAndThanksWater />} />
              
              {/* QR Experience - Symbolism page for bottle QR code */}
              <Route path="/lovewater" element={<QRExperience />} />
              <Route path="/qr" element={<QRExperience />} />
              <Route path="/simbolismo" element={<QRExperience />} />
              <Route path="/water" element={<QRExperience />} />
              
              {/* B2B SaaS Landing Page */}
              <Route path="/b2b" element={<B2BLanding />} />
              
              {/* System Panel - Private dev dashboard */}
              <Route path="/system" element={<SystemPanel />} />

              {/* Public ticket viewer (QR link, 30 day TTL, no auth) */}
              <Route path="/t/:token" element={<PublicTicket />} />
              
              {/* Root and catch-all: redirect to generic menu (no table) */}
              <Route path="/" element={<Navigate to="/menu" replace />} />
              <Route path="/*" element={<Navigate to="/menu" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
        </TabletModeProvider>
      </SelectionProvider>
    </LanguageProvider>
  </ThemeProvider>
  );
}

export default App;
